import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { PromptForDefaultStoreDialogComponent } from './prompt-for-default-store-dialog/prompt-for-default-store-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SelectFieldStoreModule } from '../components/forms/fields/select-field-store/select-field-store.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    SelectFieldStoreModule,
    LoginRoutingModule
  ],
  declarations: [LoginComponent, PromptForDefaultStoreDialogComponent]
})
export class LoginModule { }
